<template>
  <div :class="`tag ${icon ? 'has-icon' : ''} ${removeable ? 'removeable' : ''}`">
    <div class="livedot"></div>
    <i :class="`icon-${icon} tag-icon`" v-if="icon" />
    <span>
      <slot />
    </span>
    <i class="icon-close-small removeable-icon" v-if="removeable" @click="$emit('remove', true)" />
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    removeable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  align-items: center;
  background: #868B97;
  border-radius: 16px;
  display: inline-flex;
  padding: 6px 12px;
  position: relative;

  span {
    font-size: 15px;
    color: #FFFFFF;
    line-height: 20px;
  }

  &.has-icon {
    padding-left: 32px;
  }

  &.removeable {
    padding-right: 32px;
  }

  i {
    color: white;
    font-size: 22px;
    position: absolute;
    transform: translateY(-50%);
    top: 50%;

    &.tag-icon {
      left: 7px;
    }

    &.removeable-icon {
      right: 7px;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
